// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25387ebe","239":"745ebd41","455":"74c2d0c7","762":"1a69f5ee"}[chunkId] + ".chunk.js";
};